<template>
  <ZESACalculator />
</template>

<script>
import ZESACalculator from "./components/ZESACalculator.vue";

export default {
  name: "App",
  mounted() {
    let externalScript = document.createElement("script");
    externalScript.setAttribute(
      "src",
      "https://www.payfast.co.za/onsite/engine.js"
    );
    document.head.appendChild(externalScript);
  },
  components: {
    ZESACalculator,
  },
};
</script>

<style></style>
